import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

export default function NavigationBar() {
  return (
    <AppBar position="static">
      <Toolbar>
        <Container>
          <Typography
            href="/"
            component="a"
            variant="h6"
            color="inherit"
            noWrap
            sx={{
              fontWeight: 700,
              textDecoration: 'none',
            }}
          >
            KnapsackLabs
          </Typography>
        </Container>
      </Toolbar>
    </AppBar>
  );
}
